import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Toaster } from '../components/ui/sonner';
import { Menu, X, Clock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const Layout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user } = useAuth();
  const { lang } = useLanguage();
  const it = lang === 'it';

  // Trial banner logic
  let trialBanner = null;
  if (user && user.role !== 'superadmin' && !user.is_paid && user.trial_end) {
    const now = new Date();
    const end = new Date(user.trial_end);
    if (now < end) {
      const hoursLeft = Math.ceil((end - now) / (1000 * 60 * 60));
      const daysLeft = Math.ceil(hoursLeft / 24);
      trialBanner = (
        <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-center gap-2 text-sm text-amber-800">
          <Clock className="w-4 h-4" />
          {it
            ? `Trial gratuito: ${daysLeft > 1 ? `${daysLeft} giorni rimanenti` : `${hoursLeft} ore rimanenti`}`
            : `Free trial: ${daysLeft > 1 ? `${daysLeft} days left` : `${hoursLeft} hours left`}`
          }
        </div>
      );
    }
  }

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ backgroundColor: 'var(--background-body)', color: 'var(--text-main)' }}>
      {/* Mobile header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 border-b px-4 py-3 flex items-center justify-between" style={{ backgroundColor: 'var(--background-surface)', borderColor: 'var(--background-subtle)' }}>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 rounded-lg" data-testid="mobile-menu-btn">
          {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
        <h1 className="font-outfit text-lg font-semibold">RistoMetrix</h1>
        <div className="w-9" />
      </div>

      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-40" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} onClick={() => setMobileMenuOpen(false)} />
      )}

      {/* Sidebar */}
      <div className={`fixed left-0 top-0 h-screen z-50 transition-transform duration-200 ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
        <Sidebar onNavigate={() => setMobileMenuOpen(false)} />
      </div>

      {/* Main content */}
      <main className="lg:ml-64 min-h-screen pt-14 lg:pt-0">
        {trialBanner}
        <div className="max-w-7xl mx-auto px-3 py-3 sm:p-4 lg:p-6">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default Layout;
